export const COUNTRY_OPTIONS = [
  ["", "admin.crm.customerCard.options.country.unspecified"],
  ["SE", "admin.crm.customerCard.options.country.SE"],
  ["NO", "admin.crm.customerCard.options.country.NO"],
  ["DK", "admin.crm.customerCard.options.country.DK"],
  ["FI", "admin.crm.customerCard.options.country.FI"],
  ["DE", "admin.crm.customerCard.options.country.DE"],
  ["OTHER", "admin.crm.customerCard.options.country.other"],
];

export const CUSTOMER_STATUS_OPTIONS = [
  ["ACTIVE", "admin.crm.customerCard.options.status.active"],
  ["ON_HOLD", "admin.crm.customerCard.options.status.onHold"],
  ["INACTIVE", "admin.crm.customerCard.options.status.inactive"],
];

export const PAYMENT_METHOD_OPTIONS = [
  ["INVOICE", "admin.crm.customerCard.options.payment.invoice"],
  ["BANK_TRANSFER", "admin.crm.customerCard.options.payment.bankTransfer"],
  ["CARD", "admin.crm.customerCard.options.payment.card"],
  ["SWISH", "admin.crm.customerCard.options.payment.swish"],
  ["OTHER", "admin.crm.customerCard.options.payment.other"],
];

export const CURRENCY_OPTIONS = [["SEK"], ["EUR"], ["NOK"], ["DKK"]];

export const DISTRIBUTION_OPTIONS = [
  ["UNIQUEUE", "admin.crm.customerCard.options.distribution.uniqueue"],
  ["EMAIL", "admin.crm.customerCard.options.distribution.email"],
  ["E_INVOICE", "admin.crm.customerCard.options.distribution.eInvoice"],
  ["PDF", "admin.crm.customerCard.options.distribution.pdf"],
  ["PRINT", "admin.crm.customerCard.options.distribution.print"],
];

export const REFERENCE_FIELDS = [
  ["yourReference", "admin.crm.customerCard.fields.yourReference"],
  ["ourReference", "admin.crm.customerCard.fields.ourReference"],
  ["costplace1", "admin.crm.customerCard.fields.purchaseOrderNumber"],
  ["costplace2", "admin.crm.customerCard.fields.projectNumber"],
];

export const optionLabel = (intl, options, value, fallback = value) => {
  const messageId = options.find(([optionValue]) => optionValue === value)?.[1];
  return messageId ? intl.formatMessage({ id: messageId }) : fallback;
};
